import React from "react";
import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import { Spin } from "antd";
import ChantPopConfirm from "../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { DownloadIcon, ReloadIcon } from "../../../utils/icons";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";
import dayjs from "dayjs";
import { json2csv } from "json-2-csv";
import { useNavigate } from "react-router-dom";

const GroupsHeader = ({ tableData, handleRefresh, membersCount }) => {
  const navigate = useNavigate();

  const handleDownloadCsv = (tableData) => {
    if (tableData.length === 0) {
      return;
    }

    let result = [];

    tableData?.forEach((value) => {
      let rm = value?.registeredMembers || 0;
      let tm = value?.totalMembers || 0;
      let val = (rm / tm) * 100;
      const registeredPercentage =
        (Number.isNaN(val) ? 0 : Math.round(val)) + "%";

      const hasStripe =
        value.paymentDetails && value.paymentDetails.stripeAccountId
          ? "Yes"
          : "No";

      let row = {
        "Group Name": value?.groupName || "",
        "Group ID": value?.id || "",
        Owner: value?.owner || "",
        Stage: value?.status || "",
        "Next Outreach Date": value?.nextOutreachDate
          ? dayjs(value?.nextOutreachDate).format("MMM DD, YYYY")
          : "",
        Adoption: value?.adoption ? `${value?.adoption?.toFixed(0)}%` : "0%",
        "% Reg": registeredPercentage,
        Reg: value?.registeredMembers || 0,
        Pending: value?.preRegisteredMemberCount || 0,
        Total: value?.totalMembers || 0,
        "Stripe?": hasStripe,
        Website: value?.websitePublished ? "Yes" : "No",
        Directory: value?.directoryPublished ? "Yes" : "No",
        Stadium: value?.stadiumPublished ? "Yes" : "No",
        "Global post": value?.clubPostAllowed ? "Yes" : "No",
        Club: value?.clubName || "",
        League: value?.leagueName || "",
        "Renewal Date": dayjs.unix(value?.renewalDate).format("YY-MM-DD") || "",
        Admins: [...(value?.admins?.[0] || []), ...(value?.admins?.[1] || [])]
          ?.map((val) => `${val.name}`)
          .join(", "),
        AdminEmails: [
          ...(value?.admins?.[0] || []),
          ...(value?.admins?.[1] || []),
        ]
          .map((val) => val?.email)
          .filter(Boolean)
          .join(", "),
        "Group Type": value?.groupType || "",
      };
      result.push(row);
    });
    const csv = json2csv(result);

    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "GiveawayEntries.csv";

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloading = false;
  return (
    <ScreenHeader
      title={"Groups"}
      elementCount={tableData?.length || 0}
      secondaryData={
        <div>
          <h5
            style={{
              fontSize: "20px",
              marginBottom: "0px",
              display: "flex",
              gap: "6px",
            }}
          >
            <span>Members</span>
            <div>
              <span
                style={{
                  fontSize: "16px",
                  color: "gray",
                  fontWeight: "400",
                }}
              >{`(${membersCount?.totalReg || 0} / ${membersCount?.totalPending || 0} / ${membersCount?.totalMembers || 0})`}</span>
            </div>
          </h5>
        </div>
      }
      actions={
        <div className="member-actions-buttons">
          <ChantPopConfirm
            title="Download groups list?"
            onConfirm={() => handleDownloadCsv(tableData)}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
            trigger="click"
          >
            <div className="icon-container" style={{ cursor: "pointer" }}>
              {downloading ? (
                <Spin style={{ fontSize: "20px" }} />
              ) : (
                <img
                  src={DownloadIcon}
                  alt="icon"
                  style={{ fontSize: "20px" }}
                />
              )}
            </div>
          </ChantPopConfirm>

          <ChantPopConfirm
            title="Refresh Groups List?"
            onConfirm={handleRefresh}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <div className="icon-container" style={{ cursor: "pointer" }}>
              {downloading ? (
                <Spin style={{ fontSize: "20px" }} />
              ) : (
                <img src={ReloadIcon} alt="icon" style={{ fontSize: "20px" }} />
              )}
            </div>
          </ChantPopConfirm>

          <ChantButton onClick={() => navigate("/superadmin/groups/create")}>
            Create Group
          </ChantButton>
        </div>
      }
    />
  );
};

export default GroupsHeader;
